import { render } from "./gimbalControl.vue?vue&type=template&id=127d41ca&scoped=true"
import script from "./gimbalControl.vue?vue&type=script&lang=js"
export * from "./gimbalControl.vue?vue&type=script&lang=js"

import "./gimbalControl.vue?vue&type=style&index=0&id=127d41ca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127d41ca"]])

export default __exports__